import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {InventoryNumberInputComponent} from './inventory-number-input.component';
import {DatabaseLookupInputModule} from '../database-lookup-input/database-lookup-input.module';

@NgModule({
    imports: [
        PagesSharedModule,
        DatabaseLookupInputModule
    ],
    declarations: [
        InventoryNumberInputComponent
    ],
    entryComponents: [],
    exports: [
        InventoryNumberInputComponent
    ]
})
export class InventoryNumberInputModule {
}
